"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_scroll_1 = require("react-scroll");
var cart_info_1 = require("../../ducks/cart-info");
var onPlatform_1 = require("../../ducks/onPlatform");
var H_1 = __importDefault(require("../../../common/Typography/H"));
var P_1 = __importDefault(require("../../../common/Typography/P"));
var GenericButton_1 = __importDefault(require("../../../common/GenericButton"));
var BasketIcon_1 = __importDefault(require("../../../common/Icons/BasketIcon"));
var AddIcon_1 = __importDefault(require("../../../common/Icons/AddIcon"));
var currency_1 = require("../../../../utils/currency");
var CloseIcon_1 = __importDefault(require("../../../common/Icons/CloseIcon"));
var product_1 = require("../../ducks/product");
var cart_info_module_scss_1 = __importDefault(require("./cart-info.module.scss"));
var styled_components_1 = __importDefault(require("styled-components"));
function CartInfo() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var cartInfo = (0, react_redux_1.useSelector)(cart_info_1.cartInfoSelector);
    var onPlatform = (0, react_redux_1.useSelector)(onPlatform_1.onPlatformSelector);
    var currency = (0, react_redux_1.useSelector)(product_1.currencySelector);
    var giftWrappingPath = cartInfo.giftWrappingPath, path = cartInfo.path, size = cartInfo.size, total = cartInfo.total;
    var scrollHandler = function () {
        react_scroll_1.scroller.scrollTo('cart-info', {
            duration: 800,
            delay: 0,
            offset: -100,
            smooth: 'easeInOutQuart',
        });
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('load', scrollHandler);
        return function () {
            window.removeEventListener('load', scrollHandler);
        };
    }, []);
    return cartInfo.path ? (react_1.default.createElement("div", { className: cart_info_module_scss_1.default.root },
        react_1.default.createElement(react_scroll_1.Element, { name: "cart-info" }),
        react_1.default.createElement("div", { className: cart_info_module_scss_1.default.cart },
            react_1.default.createElement("div", { className: cart_info_module_scss_1.default.titleWrapper },
                react_1.default.createElement(H_1.default, { level: 2 }, "\u0422\u043E\u0432\u0430\u0440 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443"),
                react_1.default.createElement(IconButton, { onClick: function () { return dispatch((0, cart_info_1.setCartInfoAction)({})); } },
                    react_1.default.createElement(CloseIcon_1.default, null))),
            react_1.default.createElement("div", { className: cart_info_module_scss_1.default.price },
                react_1.default.createElement("a", { href: path },
                    react_1.default.createElement(BusketButton, { vendorStyle: "".concat(onPlatform) },
                        react_1.default.createElement(BasketIcon_1.default, { className: cart_info_module_scss_1.default.basketIcon }),
                        react_1.default.createElement("span", null, "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437"))),
                react_1.default.createElement(P_1.default, null,
                    "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0435 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 ",
                    size,
                    " \u0448\u0442. \u043D\u0430 ",
                    total,
                    ' ',
                    (0, currency_1.longCurrency)(currency, total)))),
        giftWrappingPath && (react_1.default.createElement("div", { className: cart_info_module_scss_1.default.gift },
            react_1.default.createElement(H_1.default, { level: 2 }, "\u042D\u0442\u043E \u043F\u043E\u0434\u0430\u0440\u043E\u043A?"),
            react_1.default.createElement("a", { href: giftWrappingPath },
                react_1.default.createElement(AddButton, { vendorStyle: "".concat(onPlatform, "-light") },
                    react_1.default.createElement(AddIcon_1.default, { className: cart_info_module_scss_1.default.addIcon }),
                    react_1.default.createElement("span", null, "\u0423\u043F\u0430\u043A\u043E\u0432\u0430\u0442\u044C"))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.default = CartInfo;
var IconButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"], ["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])));
var BusketButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #f44a36 !important;\n  margin: 0 20px 0px 0;\n  padding: 8px 16px;\n  font-size: 15px;\n  line-height: 1.6;\n"], ["\n  background: #f44a36 !important;\n  margin: 0 20px 0px 0;\n  padding: 8px 16px;\n  font-size: 15px;\n  line-height: 1.6;\n"])));
var AddButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: #3aad64;\n  margin: 0 20px 0px 0;\n  padding: 8px 16px;\n  font-size: 15px;\n  line-height: 1.6;\n"], ["\n  background: #3aad64;\n  margin: 0 20px 0px 0;\n  padding: 8px 16px;\n  font-size: 15px;\n  line-height: 1.6;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
